import React from 'react'
import PropTypes from 'prop-types'
import { connect as connectRedux, useSelector } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import _startsWith from 'lodash/startsWith'
import { getBoundActions } from '../../../actions/index'
import CartLayoutTemplate from '../CartLayoutTemplate/index'
import {
  ACCOUNT_TYPE_FMTV,
  USER_ACCOUNT_CANCELLED,
  isThirdPartyEntitled,
} from '../../../services/user-account/index'
import { selectHasActiveGiftSubscription } from '../../../services/user-account/selectors'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import { connect as connectStaticText } from '../../StaticText/connect'
import CartProgressIndicator from '../../CartProgressIndicator/index'
import { H1, HEADING_TYPES } from '../../Heading/index'
import CartOrderSummaryV2 from '../CartOrderSummaryV2/index'
import OptimizelyPage from '../../OptimizelyPage/index'
import AccountCreateForm from '../../AccountCreateForm/index'

function CartAccountCreatePageV2 (props) {
  const {
    location,
    paytrack,
    setCheckoutAccountCreateData,
    user,
    auth,
    dialog,
    staticText,
    userAccount,
  } = props
  const freeTrialId = user.getIn(['data', 'userFreeTrial', 'ratePlanId'])
  const isGiftSubscriptionActive = useSelector(selectHasActiveGiftSubscription)
  const gaiaAccount = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'billingAccountId'])
  const status = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'status'])
  const statusIsCancelledOrUndefined = !status || status === USER_ACCOUNT_CANCELLED
  const creationSource = user.getIn(['data', 'creation_source'])
  const creationSourceFMTV = _startsWith(creationSource, ACCOUNT_TYPE_FMTV, 0)
  const externalEmail = user.getIn(['data', 'email_registered_externally'])
  const userCreateProcessing = user.get('userCreateProcessing')
  const userLoginProcessing = auth.get('processing') && !auth.get('processingRenew')
  const userProcessing = user.get('processing')
  const handleFormSubmit = (data) => {
    setCheckoutAccountCreateData(data)
  }

  let isProcessing
  if ((freeTrialId && !gaiaAccount)
    || (isGiftSubscriptionActive && (!gaiaAccount || statusIsCancelledOrUndefined))) {
    isProcessing = false
  } else if (
    // Allow users migrated from FMTV to create an account
    (creationSourceFMTV && !gaiaAccount)
    || (!creationSourceFMTV && externalEmail && !gaiaAccount)
    || (creationSourceFMTV && !externalEmail && !gaiaAccount)
  ) {
    isProcessing = false
  } else if (isThirdPartyEntitled({ paytrack, auth })) {
    isProcessing = true
  } else if ((userLoginProcessing || userCreateProcessing) && !dialog.get('componentName')) {
    isProcessing = true
  }

  const header = !userProcessing && !userLoginProcessing && getAuthIsLoggedIn(auth) ? 'reactivateYourAccount' : 'createYourAccount'
  return (
    /* eslint-disable jsx-a11y/tabindex-no-positive */
    <div className="cart-account-create-v2">
      <CartLayoutTemplate
        colOne={
          <React.Fragment>
            <CartProgressIndicator v2 />
            <H1 as={HEADING_TYPES.H3} className="cart-account-create-v2__title">
              {staticText.getIn(['data', header])}
            </H1>
            <AccountCreateForm
              location={location}
              onFormSubmit={handleFormSubmit}
              isProcessing={isProcessing}
            />
          </React.Fragment>
        }
        colTwo={
          <div className="cart-account-create-v2__order-summary">
            <CartOrderSummaryV2 />
          </div>
        }
      />
      <OptimizelyPage pageName="web_app__cart_account_create_create" />
    </div>
    /* eslint-enable jsx-a11y/tabindex-no-positive */
  )
}

CartAccountCreatePageV2.propTypes = {
  location: PropTypes.object.isRequired,
  paytrack: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
  dialog: ImmutablePropTypes.map.isRequired,
  setCheckoutAccountCreateData: PropTypes.func.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      paytrack: state.paytrack,
      user: state.user,
      userAccount: state.userAccount,
      dialog: state.dialog,
      plans: state.plans,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setCheckoutAccountCreateData: actions.checkout.setCheckoutAccountCreateData,
      }
    },
  ),
  connectStaticText({ storeKey: 'cartAccountCreatePageV2' }),
)(CartAccountCreatePageV2)
